import React,{useEffect, useRef} from 'react'
import ErpLayout from '../../../../../layout/components/ErpLayout'
import { useState } from 'react'

import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { useAppData } from '../../../../../context/AppDataContext';
import ConfirmDialog from '../../../../../components/ConfirmDialog';
import { Print } from '@mui/icons-material';
import ProductForm from '../components/ProductForm';


const CellActions = (props) =>{
    return(
        <>
            <ProductForm  callBack={props.callBack} data={props.data} />
            <ConfirmDialog id={props.data.id} confirm={ ()=>props.remove(props.data.id)} >Are you Sure You want to remove</ConfirmDialog>
        </>
    )
  }


function ProductDashboard() {

  const {getMasterLabel} = useAppData()
  const {productList,getProductList} = useAppData();
  const gridRef = useRef();
  

  const remove = () =>{

  }

  const [defaultColDef] = useState({
    floatingFilter: true,
    filterParams: {
      buttons: ['apply'],
    },
    resizable: true,
    width:120,
    filter:true,
    sortable: true,
    cellStyle: { 'textTransform': 'uppercase' },
  });


  const [columnDefs,setColumnDef] = useState();
    const prepairColumnDef = () => {
    let _columnDefs = [
        {field:"id",headerName: "ID"},
        {field:"title",headerName: "Product Name",width:250},
        {field:"sku",headerName: "SKU"},
        
        {field:"model",headerName: "Model"},
        {field:"color",headerName: "Color"},

        
        {headerName: "Category", width:150,
          valueGetter:params=>{
            return getMasterLabel('product-category',params.data.categoryId)
          }
        },

        {headerName: "UOM", width:150,
          valueGetter:params=>{
            return getMasterLabel('product-uom',params.data.uom)
          }
        },

        {headerName: "Billing Type", width:150,
          valueGetter:params=>{
            return getMasterLabel('billing-type',params.data.billingType)
          }
        },

        {headerName: "Expense Type", width:150,
          valueGetter:params=>{
            return getMasterLabel('expense-type',params.data.expenseType)
          }
        },

        {headerName: "Inventory Type", width:150,
          valueGetter:params=>{
            return getMasterLabel('inventory-type',params.data.inventoryType)
          }
        },


        {headerName: "Brand", width:150,
          valueGetter:params=>{
            return getMasterLabel('product-brand',params.data.brandId)
          }
        },
        {field:"hsn",headerName: "HSN"},
        {field:"cost",headerName: "Cost"},
        {field:"price",headerName: "Selling Price"},
        {field:"mrp",headerName: "MRP"},
        {field:"gstRate",headerName: "GST Rate"},
        {headerName:"Action", width:"200", valueGetter: params => params.data.title,
            cellRenderer: CellActions,
            cellRendererParams: {
                callBack:getProductList,
                remove:remove
            },
        },      
    ];
    setColumnDef(_columnDefs);
  }

  const onBtnExport = () => {
    gridRef.current.api.exportDataAsCsv("data.csv");
  };

  useEffect(()=>{    
    prepairColumnDef();
  },[]);
  return (
    <ErpLayout>
      <div className='row'>
        <div className='col-md-6'><h4>Products</h4></div>
        <div className='col-md-6'> 
          <span className='float-end'><ProductForm callBack={getProductList} /></span>
          <button className='btn btn-warning me-2 float-end' onClick={onBtnExport} ><Print /> Export </button>
        </div>
        <div className='col-md-12 mt-2'>
          <div className="ag-theme-alpine" style={{height: 400}}>
              <AgGridReact
                ref={gridRef}
                rowData={productList}
                columnDefs={columnDefs}
                defaultColDef={defaultColDef}
                animateRows={true}
                onGridReady={getProductList}
              />
            </div>
          </div>
        </div>
    </ErpLayout>
    
  )
}

export default ProductDashboard